module.exports = __webpack_public_path__ + "img/allottee4_7-8-2021.01d533ab.jpg";